import React from "react";
import FullPage from "components/FullPage";
import ContentfulApi from "@utils/ContentfulApi";
import cleanDataAndAdditionalData from "utils/cleanDataAndAdditionalData";

export default function CLevelPage({ data, err, additionalData }) {
	const fields = data?.items[0]?.fields;
	return (
		<>
			{!fields && "No fields for C-Level Page"}
			<FullPage pageData={data} additionalData={additionalData} />
		</>
	);
}

export async function getStaticProps() {
	try {
		let _data = await ContentfulApi.getPage("C-Level Page");
		const { data, additionalData } = await cleanDataAndAdditionalData({ pageData: _data });

		return {
			props: {
				data,
				additionalData,
			},
			...(process.env.REVALIDATE_TIMER && { revalidate: process.env.REVALIDATE_TIMER }),
		};
	} catch (err) {
		console.error(err);
		return {
			props: {
				err: err.msg,
			},
		};
	}
}
